export default (function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.ca.config.FlowConfig.Error creating claim',
                message: 'fnol.ca.config.FlowConfig.An error occurred attempting to create your commercial auto claim.'
            },
            progress: {
                message: 'fnol.ca.config.FlowConfig.Creating commercial auto draft claim...'
            }
        },
        saveClaim: {
            error: {
                title: 'fnol.ca.config.FlowConfig.Error saving claim',
                message: 'fnol.ca.config.FlowConfig.An error occurred attempting to save your commercial auto claim.'
            },
            progress: {
                message: 'fnol.ca.config.FlowConfig.Saving commercial auto draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(model) {
            if (model.claimNumber.value) {
                return $q.resolve(model);
            }
            return LoadSaveService.createClaim(model.value);
        },
        saveClaim: function saveClaim(model) {
            return LoadSaveService.saveClaim(model.value);
        }
    };

    function fleetStepCanBeSkipped(claim) {
        return claim.lobs.commercialAuto.value.vehicleIncidents && claim.lobs.commercialAuto.value.vehicleIncidents.length > 0;
    }

    return function (step, junction) {
        junction('caError');
        junction('caSuccess');

        step('caClaimType', true).onNext.doAction(function (model) {
            return ACTIONS.createClaim(model);
        }, ACTION_MSG.createClaim, { forceUpdate: true }).thenBranch(function (_ref) {
            var claim = _ref.value;

            var nextStep = 'caCollisionLossDetails';
            switch (claim.getLossCategory()) {
                case 'glass':
                    nextStep = 'caFleet';
                    break;
                case 'theft':
                    nextStep = 'caFleet';
                    break;
                case 'collision':
                    nextStep = 'caCollisionLossDetails';
                    break;
                default:
                    nextStep = 'caError';
                    break;
            }
            return nextStep;
        }).skipOnResumeIf(function (_ref2) {
            var claim = _ref2.value;
            return claim.policy;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.What');
        });

        step('caTheftDetails').onNext.goTo('caSuccess').skipOnResumeIf(function (_ref3) {
            var claim = _ref3.value;
            return claim.lossCause === 'theftentire' && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.TheftDetails');
        });

        step('caGlassDetails').onNext.goTo('caSuccess').skipOnResumeIf(function (_ref4) {
            var claim = _ref4.value;
            return claim.lossCause === 'glassbreakage' && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.GlassDetails');
        });

        step('caCollisionLossDetails').onNext.goTo('caFleet').skipOnResumeIf(function (_ref5) {
            var claim = _ref5.value;
            return claim.lossCause === 'vehcollision' && claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.CollisionDetails');
        });

        step('caFleet').onNext.doAction(function (model) {
            return ACTIONS.saveClaim(model).then(function (res) {
                res.lobs.commercialAuto.value.generateVehicleIncidents(res.lobs.commercialAuto.vehicles.value);
                return res;
            });
        }, ACTION_MSG.saveClaim).thenBranch(function (_ref6) {
            var claim = _ref6.value;

            var nextStep = 'caSuccess';
            switch (claim.getLossCategory()) {
                case 'glass':
                    nextStep = 'caGlassDetails';
                    break;
                case 'theft':
                    nextStep = 'caTheftDetails';
                    break;
                case 'collision':
                    nextStep = 'caCollisionVehicles';
                    break;
                default:
                    nextStep = 'caError';
                    break;
            }
            return nextStep;
        }, function () {
            return 'caError';
        }).skipOnResumeIf(fleetStepCanBeSkipped).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.Fleet');
        });

        step('caCollisionVehicles').onNext.branch(function () {
            return 'caSuccess';
        })
        // always resume on this step because there are no required field and
        // we cannot detect that the user entered the data on it
        .skipOnResumeIf(function () {
            return false;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.steps.ca.Vehicles');
        });
    };
});